<!-- Desktop Tires Header -->
<app-header-sidebar-menu (sidebarState)="onSidebarStateChange($event)"></app-header-sidebar-menu>
 <app-header-promotion [custom_ticker]="custom_ticker"></app-header-promotion>

<div class=" header-wrapper d-none d-md-block normal-header" [class.show]="!isSticky">
    <div class="container-fluid">
    <div class="row align-items-start my-2">
        <div class="col-6 col-sm-6 col-md-12 col-lg-2 col-xl-2 col-xxl-3">
            <div class="d-flex justify-content-center">
                <app-header-logo *ngIf="showLogo"></app-header-logo>
            </div>
        </div>
        <div class="col-sm-12 col-md-10 col-lg-8 col-xl-8 col-xxl-7">
            <div class="row">
                <div class="col-10 col-lg-12 col-xl-10">
                    <div
                        class="d-flex align-items-center justify-content-start  justify-content-lg-start justify-content-xl-center">
                        <app-header-nav *ngIf="showFirstRowHeader"></app-header-nav>
                    </div>
                </div>
            </div>
            <div class="row  justify-content-center">
                <div class="col-12 col-md-10" [ngClass]="{ 'left-width': isWishlist}">
                    <app-header-search></app-header-search>
                </div>
                <div class="col-4 col-md-2 d-flex justify-content-center " [ngClass]="{ 'right-width': isWishlist}">
                    <div class="d-flex justify-content-start p-0">
                        <app-header-cart-section *ngIf="showSecondRowHeader"></app-header-cart-section>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-sm-12 col-md-2 col-lg-2 col-xl-2 col-xxl-2">
            <app-header-contact-us-section></app-header-contact-us-section>
            <app-header-my-garage-section></app-header-my-garage-section>
        </div>
    </div>
</div>
</div>

<!-- Sticky Header -->
<div class="sticky-header d-none d-md-block" [class.show]="isSticky">
    <div class="sticky-menu" [ngClass]="{ 'sticky-active': isSticky }">
        <app-header-sidebar-menu (sidebarState)="onSidebarStateChange($event)"></app-header-sidebar-menu>
    </div>
    <div class="header-wrapper py-3">
        <div class="row px-3">
            <div class="col-md-12 col-lg-3 text-center text-lg-center logo-tabs  ps-5 d-flex justify-content-center"
                [routerLink]="'/'" (click)="onButtonClick()">
                <img *ngIf="showLogo" [src]="cdnImagePath + headerdata?.websiteHeader[firstObj + 2]?.desktop_logo"
                    alt="Logo" class="img-fluid d-none d-md-block desktop-img cursor-pointer" fetchpriority="high"
                    width="170" height="56" />
            </div>
            <div class="col-md-9 col-lg-7">
                <div class="row">
                    <div class="col-12 mt-1 col-md-9 col-lg-8 col-xl-10 mt-3 tires-col-left "
                        [ngClass]="{ 'left-width': isWishlist}">
                        <app-header-search></app-header-search>
                    </div>
                    <div class="col-4 col-md-2 col-lg-4 col-xl-2 mt-3 tires-col-right "
                        [ngClass]="{ 'right-width': isWishlist}">
                        <div class="d-flex justify-content-start p-0">
                            <app-header-cart-section *ngIf="showSecondRowHeader"
                                [showdowntooltip]="showdowntooltip"></app-header-cart-section>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-3 col-lg-2">
                <app-header-my-garage-section></app-header-my-garage-section>
            </div>
        </div>
    </div>
</div>

<!-- Mobile Header -->
<div class="container-fluid d-md-none px-4">
    <app-header-mobile-menu [headerSettings]="headerSettings" [custom_ticker]="custom_ticker"></app-header-mobile-menu>
</div>
<app-shopping-cart *ngIf="showCart"></app-shopping-cart>